module.exports = __webpack_public_path__ + "static/media/star-5.38bbacc5.svg";